import styled from 'styled-components'

import { palette } from '../../../theme/palette'

export const WelcomeMessageContainer = styled.div.attrs(() => ({
  'data-test': 'welcome-msg-container'
}))<{ isFirstMessageInCurrentFlow: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
  margin-top: ${props => props.isFirstMessageInCurrentFlow ? 20 : 0}px;
`

export const WelcomeMessageAvatar = styled.img`
  width: 100px;
  height: 100px;
  margin-bottom: 24px;
`

export const NateraLogo = styled.img`
  width: 154px;
  margin-bottom: 24px;
`

export const WelcomeMessageTitle = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${palette.mainText};
  text-align: center;
  margin: 0;
`

export const WelcomeMessageSubTitle = styled.p`
  margin: 4px 0 0;
`
